export default __webpack_public_path__ + "static/PilatesBall-41012ec19b18590c01019e457599a983.png";